import type { FtcContactRow } from "@shared/recordSummary";
import { RecordPanel } from "./RecordFrame";
import { dayLabel, localYmd } from "./recordFormat";

const plural = (n: number, w: string) => `${n} ${w}${n === 1 ? "" : "s"}`;

/** Who at FTC emails or meets with them, counted from synced email and meetings. */
export function RailFtcContact({ rows, loading, error }: { rows: FtcContactRow[] | undefined; loading: boolean; error?: boolean }) {
  const today = localYmd(new Date());
  return (
    <RecordPanel title="FTC contact" action={<span className="text-[11px] text-muted-foreground">from email and meetings</span>}>
      {error ? <p className="text-[12.5px] text-muted-foreground">Couldn't load.</p>
        : loading ? <p className="text-[12.5px] text-muted-foreground">Loading…</p>
        : !rows?.length ? <p className="text-[12.5px] text-muted-foreground">No emails or meetings with anyone at FTC yet.</p>
        : (
          <ul className="divide-y">
            {rows.map((r) => (
              <li key={r.userId} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-2 py-1.5 text-[12.5px]">
                <span className="font-semibold">{r.name}</span>
                <span className="row-span-2 self-center text-right text-xs tabular-nums text-muted-foreground">{dayLabel(r.lastAt, today)}</span>
                <span className="text-[11.5px] text-muted-foreground">
                  {[r.emails ? plural(r.emails, "email") : null, r.conversations ? plural(r.conversations, "conversation") : null].filter(Boolean).join(" · ")}
                </span>
              </li>
            ))}
          </ul>
        )}
    </RecordPanel>
  );
}
